<template>
  <div class="user-info-edit">
    <van-nav-bar
      title="个人信息"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="page-content">
      <div class="form-content">
        <div class="avatar-section">
          <van-uploader
            :after-read="onAvatarRead"
            :before-read="beforeRead"
            accept="image/jpeg,image/jpg,image/png"
          >
            <div class="avatar-upload-area">
              <img
                v-if="form.avatarPath"
                :src="form.avatar"
                alt="头像"
                class="avatar-preview"
              />
              <div v-else class="avatar-placeholder">
                <div class="placeholder-icon"></div>
              </div>
              <!-- 删除按钮 -->
              <div v-if="form.avatarPath" class="delete-avatar-btn" @click.stop="deleteAvatar">
                <van-icon name="cross" size="14" />
              </div>
            </div>
          </van-uploader>
          <!-- 旋转控制按钮（移到上传区域外，避免被裁剪） -->
          <div v-if="form.avatarPath" class="rotate-controls">
            <van-button
              size="small"
              round
              @click="rotateImage(-90)"
              title="逆时针旋转90°"
            >
              ↺ 逆时针
            </van-button>
            <van-button
              size="small"
              round
              @click="rotateImage(90)"
              title="顺时针旋转90°"
            >
              ↻ 顺时针
            </van-button>
            <van-button
              size="small"
              round
              @click="rotateImage(180)"
              title="旋转180°"
            >
              ⟲ 180°
            </van-button>
          </div>

          <div class="upload-tips">
            <p class="tips-text">剪切时请将图片填充到框内,四周不要留空</p>
            <p class="warning-text">请勿使用二次拍摄的照片<br />建议现场拍摄</p>
          </div>

          <div class="upload-instructions">
            <p>1. 请现场使用摄像头拍照（优先）或者上传近期证件照片。</p>
            <p>
              2.
              此处上传本人的照片，请【不要上传无关照片】，将用于颁发证书
            </p>
            <p>
              3.
              【不要使用若干年前的老照片片或者艺术照】等。也【不要使用手机去拍摄身份证等证件上面的照片】
            </p>
          </div>
        </div>

        <div class="form-section">
          <div class="field-item">
            <van-form ref="formRef" @submit="onSubmit">
              <van-field
                v-model="form.name"
                placeholder="请输入姓名"
                class="custom-field"
                error
                required
                label="姓名"
                name="姓名"
                :rules="[{ required: true, message: '请输入姓名'}]"
              />

              <van-field
                v-model="form.idCardText"
                placeholder="请选择证件类型"
                readonly
                is-link
                @click="showIdTypePicker = true"
                class="custom-field"
                required
                label="证件类型"
                name="证件类型"
                :rules="[{ required: true, message: '请选择证件类型' }]"
              />

              <van-field
                v-model="form.idCard"
                placeholder="请输入证件号"
                class="custom-field"
                required
                label="证件号"
                name="证件号"
                :rules="[{ required: true, message: '请输入证件号' }]"
              />

              <!-- <van-field
                v-model="form.birthDate"
                placeholder="请选择出生日期"
                readonly
                is-link
                @click="showDatePicker = true"
                class="custom-field"
                required
                label="出生日期"
                name="出生日期"
                :rules="[{ required: true, message: '请选择出生日期' }]"
              /> -->

              <van-field
                v-model="form.mobile"
                placeholder="请输入手机号"
                type="tel"
                maxlength="11"
                class="custom-field"
                required
                label="手机号"
                name="手机号"
                :rules="[
                  { required: true, message: '请输入手机号' },
                  { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
                ]"
              />

              <van-field
                v-model="form.email"
                placeholder="请输入邮箱"
                class="custom-field"
                required
                label="邮箱"
                name="邮箱"
                :rules="[
                  { required: true, message: '请输入邮箱' },
                  { pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: '请输入正确的邮箱格式' }
                ]"
              />
              <van-field
                name="性别"
                label="性别"
                class="custom-field"
                v-model="form.gender"
                required
                :rules="[{ required: true, message: '请选择性别' }]"
              >
                <template #input>
                  <van-radio-group v-model="form.gender" direction="horizontal">
                    <van-radio name="m">男</van-radio>
                    <van-radio name="f">女</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-form>
          </div>
        </div>
      </div>

      <div class="save-section">
        <van-button
          class="save-btn"
          type="primary"
          @click="handleSave"
          :loading="loading"
        >
          保存
        </van-button>
      </div>
    </div>

    <van-popup v-model:show="showIdTypePicker" position="bottom">
      <van-picker
        :columns="idTypeOptions"
        @confirm="onIdTypeConfirm"
        @cancel="showIdTypePicker = false"
        :columns-field-names="{
          text: 'label',
          value: 'value'
        }"
      />
    </van-popup>

    <!-- <van-popup v-model:show="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onDateConfirm"
      />
    </van-popup> -->
  </div>
</template>

<script setup>
import { getFileFullUrl,idTypeOptions } from "@/utils";
import { onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { Toast } from "vant";
import { postWithFile, put, get } from "@/request.js";
import { fixImageOrientation, rotateImage as rotateImageUtil, fileToDataURL, blobToFile, urlToFile } from "@/utils/imageUtils";

const router = useRouter();

const getcardText=(value)=>{
  return idTypeOptions.find((item) => item.value === value)?.label || "-";
}
// 表单与状态
const form = reactive({
  avatar: "",
  name: "",
  idCardType: 'ID_CARD',
  idCardText: '身份证',
  idCard: "",
  // birthDate: '',
  mobile: "",
  email: "",
  gender: "",
});
const loading = ref(false);
const showIdTypePicker = ref(false);
const formRef = ref(null);
const currentFile = ref(null); // 当前处理的文件对象
const rotationAngle = ref(0); // 当前旋转角度
// const currentDate = ref(new Date());
// const maxDate = ref(new Date());
// const minDate = ref(new Date(1900, 0, 1));

// 返回
const onClickLeft = () => {
  router.back();
};

// 头像上传前验证
const beforeRead = (file) => {
  if (file.type !== "image/jpeg" && file.type !== "image/png") {
    Toast("请选择 jpg 或 png 格式的图片");
    return false;
  }
  if (file.size > 3 * 1024 * 1024) {
    Toast("图片大小不能超过 3MB");
    return false;
  }
  return true;
};
const onIdTypeConfirm = (value) => {
  form.idCardText= value.label;
  form.idCardType= value.value;
  showIdTypePicker.value = false;
};

// 选择头像后
const onAvatarRead = async (file) => {
  try {
    // 先修正EXIF方向
    const correctedFile = await fixImageOrientation(file.file);
    currentFile.value = correctedFile;
    rotationAngle.value = 0; // 重置旋转角度
    
    // 预览图片
    form.avatar = await fileToDataURL(correctedFile);
    
    // 上传到服务器
    await uploadAvatar(correctedFile);
  } catch (error) {
    console.error("处理图片失败:", error);
    Toast("图片处理失败");
  }
};

// 上传头像到服务器
const uploadAvatar = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const res = await postWithFile("/api/upload", formData);
    if (res.success && res?.data) {
      form.avatarPath = res.data.path;
      Toast("头像上传成功，您可以旋转调整方向");
    } else {
      Toast("头像上传失败");
    }
  } catch (error) {
    Toast("头像上传失败");
  }
};

// 旋转图片
const rotateImage = async (degrees) => {
  try {
    // 如果没有currentFile，尝试从URL下载图片
    if (!currentFile.value && form.avatarPath) {
      const avatarUrl = form.avatar.startsWith('http') ? form.avatar : getFileFullUrl(form.avatarPath);
      currentFile.value = await urlToFile(avatarUrl, 'avatar.jpg');
      rotationAngle.value = 0; // 重置旋转角度
    }
    
    if (!currentFile.value) {
      Toast("请先上传图片");
      return;
    }
    
    // 更新旋转角度（用于预览显示）
    rotationAngle.value = (rotationAngle.value + degrees) % 360;
    
    // 基于当前文件旋转指定角度（增量旋转）
    const rotatedBlob = await rotateImageUtil(currentFile.value, degrees);
    
    // 更新预览
    const previewUrl = await fileToDataURL(rotatedBlob);
    form.avatar = previewUrl;
    
    // 更新当前文件（用于下次旋转）
    currentFile.value = blobToFile(rotatedBlob, currentFile.value.name || 'avatar.jpg');
    
    // 重新上传旋转后的图片
    const formData = new FormData();
    formData.append("file", currentFile.value);
    const res = await postWithFile("/api/upload", formData);
    if (res.success && res?.data) {
      form.avatarPath = res.data.path;
      Toast("图片已旋转并上传");
    } else {
      Toast("保存旋转后的图片失败");
    }
  } catch (error) {
    console.error("旋转失败:", error);
    Toast("图片旋转失败");
  }
};

// 删除头像
const deleteAvatar = () => {
  form.avatar = "";
  form.avatarPath = "";
  currentFile.value = null;
  rotationAngle.value = 0;
  Toast("头像已删除");
};

// const onDateConfirm = (value) => {
//   const year = value.getFullYear();
//   const month = String(value.getMonth() + 1).padStart(2, '0');
//   const day = String(value.getDate()).padStart(2, '0');
//   // form.birthDate = `${year}-${month}-${day}`;
//   showDatePicker.value = false;
// };



// 保存
const handleSave = async () => {
  loading.value = true;
  
  try {
    // 表单验证
    await formRef.value?.validate();
    
    const params = {
      ...form,
      avatar: form.avatarPath,
    };
    delete params.avatarPath;
    
    // 发送请求
    const res = await put("/api/my/home/updateInfo-simple", params);
    
    if (res.success) {
      Toast("保存成功");
      setTimeout(() => {
        router.back();
      }, 1000);
    } else {
      // 如果 success 为 false，显示错误信息
      Toast(res.message || res.debug || "保存失败，请稍后重试");
    }
  } catch (error) {
    // 捕获表单验证错误或网络错误
    console.error("保存失败:", error);
    
    // 如果是表单验证错误，Vant 会自动显示错误信息，这里不需要额外处理
    // 如果是网络错误或其他错误，显示错误提示
    if (error && error.message && !error.message.includes("validation")) {
      Toast(error.message || "保存失败，请稍后重试");
    }
  } finally {
    loading.value = false;
  }
};

// 兼容模板中的 @submit
const onSubmit = () => {

  handleSave();
};
const getUserInfo = async () => {
  const res = await get("/api/my/home/getInfo");
  if (res.success) {
    const { avatar, name, idCard, mobile, email, gender, idCardText, idCardType } = res.data;
    form.avatar = getFileFullUrl(avatar);
    form.avatarPath = avatar;
    form.name = name;
    form.idCard = idCard;
    form.mobile = mobile;
    form.email = email;
    form.gender = gender;
    // 如果后端返回了证件类型，使用返回的值；否则使用默认值"身份证"
    form.idCardType = idCardType || 'ID_CARD';
    form.idCardText = idCardType ? getcardText(idCardType) : '身份证';
  }
};
onMounted(() => {
  getUserInfo();
});
</script>

<style lang="less" scoped>
.user-info-edit {
  min-height: 100vh;
  height: 100vh;

  .page-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px 16px;
  }

  // 头像上传区域
  .avatar-section {
    background: #fff;
    border-radius: 12px;
    padding:5px 20px;
    margin-bottom: 20px;
    text-align: center;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

    .avatar-upload-area {
      width: 120px;
      height: 160px;
      margin: 0 auto 16px;
      border: 2px dashed #ddd;
      border-radius: 8px;
      position: relative;
      overflow: hidden; // 保持hidden，图片区域需要裁剪
      background: #fafafa;

      .avatar-preview {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .avatar-placeholder {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .placeholder-icon {
          width: 50px;
          height: 50px;
          background: #ddd;
          border-radius: 50%;
          position: relative;

          &::before {
            content: "";
            position: absolute;
            top: 15px;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 15px;
            background: #fff;
            border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
          }

          &::after {
            content: "";
            position: absolute;
            bottom: 8px;
            left: 50%;
            transform: translateX(-50%);
            width: 30px;
            height: 12px;
            background: #fff;
            border-radius: 15px 15px 0 0;
          }
        }
      }

      // 删除按钮样式
      .delete-avatar-btn {
        position: absolute;
        top: 2px;
        right: 2px;
        width: 24px;
        height: 24px;
        background: #ff4757;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s ease;
        z-index: 10;

        &:hover {
          background: rgba(0, 0, 0, 0.8);
          transform: scale(1.1);
        }

        &:active {
          transform: scale(0.95);
        }

        :deep(.van-icon) {
          color: #fff;
        }
      }

    // 旋转控制按钮（移到上传区域外）
    .rotate-controls {
      display: flex;
      justify-content: center;
      gap: 8px;
      margin-top: 12px;
      margin-bottom: 16px;

      .van-button {
        min-width: 80px;
        height: 36px;
        padding: 0 12px;
        font-size: 14px;
        background: #1890ff;
        border: none;
        color: #fff;

        &:active {
          background: #40a9ff;
        }
      }
    }
    }

    .upload-tips {
      margin-bottom: 16px;

      .tips-text {
        color: #666;
        font-size: 14px;
        margin-bottom: 8px;
      }

      .warning-text {
        color: #ff4757;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.4;
      }
    }

    .upload-instructions {
      text-align: left;
      font-size: 16px;
      color: #333;
      line-height: 1.5;

      p {
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  // 表单区域
  .form-section {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

    .field-item {
      border-bottom: 1px solid #f5f5f5;

      &:last-child {
        border-bottom: none;
      }

      .custom-field {
        font-size: 16px;
        padding: 16px 16px;
        /deep/ .van-field__error-message {
          font-size: 16px;
        }

        /deep/ .van-field__control {
          font-size: 16px;
          color: #333;

          &::placeholder {
            color: #999;
            font-size: 16px;
          }
        }
      }
    }
  }

  // 保存按钮区域
  .save-section {
    margin-top: 40px;
    padding: 0 20px 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    .save-btn {
      background: linear-gradient(135deg, #1890ff, #36cfc9);
      border: none;
      width: 80%;
      border-radius: 26px;
      font-size: 16px;
      font-weight: 500;
      padding: 26px;
    }
  }
}

// 全局样式覆盖
:deep(.van-nav-bar) {
  .van-nav-bar__title {
    font-size: 18px;
    font-weight: 600;
  }
}

/deep/ .van-popup {
  border-radius: 12px 12px 0 0;
}
</style>
